import { Injectable } from '@angular/core';
import { InternationalizationService } from '../services/internationalization.service';
import { DecimalPipe } from '@angular/common';

@Injectable()
export class SolutionUtilsService {

  constructor(
    public internationalization: InternationalizationService,
    private dp: DecimalPipe
  ) { }


  public getCostValue(value: number): number {
    if (!value || value == 0) {
      return 0;
    } else if (value > 4800000) {
      return 5;
    } else {
      var c = (value * 5) / (5000000);
      return Math.ceil(c);
    }
  }

  public maskCostValue(value: number, code): string {
    return this.dp.transform(value, '', code);

  }

  public getMaskValue(value: number): number {
    if (!value || value == 0) {
      return 0;
    } else if (value > 4000000) {
      return 5;
    } else {
      var c = (value * 5) / (60);
      return Math.ceil(c);
    }
  }

  public maskTimeValue(value: number): string {

    var month = 'mês';
    var year = 'ano';
    var months = 'meses';
    var years = 'anos';
    var years = 'anos';
    var about = 'cerca de';
    var morethan = 'mais que';
    var to = 'a'
    var from = 'de'

    var response;

    this.internationalization.translate.get('painel-dashboard/month').subscribe((text: string) => {
      month = text;
    });
    this.internationalization.translate.get('painel-dashboard/year').subscribe((text: string) => {
      year = text;
    });
    this.internationalization.translate.get('painel-dashboard/months').subscribe((text: string) => {
      months = text;
    });
    this.internationalization.translate.get('painel-dashboard/years').subscribe((text: string) => {
      years = text;
    });
    this.internationalization.translate.get('painel-dashboard/about').subscribe((text: string) => {
      about = text;
    });
    this.internationalization.translate.get('painel-dashboard/more-than').subscribe((text: string) => {
      morethan = text;
    });
    this.internationalization.translate.get('painel-dashboard/to').subscribe((text: string) => {
      to = text;
    });
    this.internationalization.translate.get('painel-dashboard/from').subscribe((text: string) => {
      from = text;
    });
    switch (value) {
      case 1:
        response = `${from} 3 ${to} 6 ${months}`
        break;
      case 2:
        response = `${from} 6 ${months} ${to} 1 ${year}`
        break;
      case 3:
        response = `${from} 1 ${to} 2 ${years}`
    
        break;
      case 4:
        response = `${from} 2 ${to} 5 ${years}`
        
        break;
      case 5:
        response = `${morethan} 5 ${years}`
        break;

      default:
        response = `${from} 0 ${to} 3 ${months}`

        break;
    }

     /* if (!value || value == 0) {
      response = '';
    } else if (value > 4000000) {
      response = `${morethan} 5 ${years}`;
    } else {

      var c = (value * 5) / (60);

      if (value == 1)
        response = `1 ${month}`;
      else if (value > 58)
        response = `${morethan} 5 ${years}`;
      else {

        var yearval = Math.floor(value / 12);
        var monthval = Math.ceil(value - (yearval * 12));

        if (yearval == 0)
          response = `${about} ${monthval} ${months}`;
        else if (yearval == 1)
          response = `${about} ${1} ${year}`;
        else if (yearval > 1) {
          if (monthval > 0)
            response = `${about} ${yearval} ${years}, ${monthval} ${months}`;
          else
            response = `${about} ${yearval} ${years}`;
        }
      }
    }  */
    return response;
  }
}
